import { render, staticRenderFns } from "./IndicadorVentas.vue?vue&type=template&id=62659280&"
import script from "./IndicadorVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadorVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports